// extracted by mini-css-extract-plugin
export default {"suggestion":"SuggestedRow-suggestion_eN77Q","pricesContainer":"SuggestedRow-pricesContainer_V7CVN"};